import React, { useEffect, useState } from 'react'
import FormContainer from '../components/FormContainer'
import { Form, Row, Col, Button } from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { userLoginAction } from '../actions/userActions'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { FRONT_URL } from '../constants/urlConstants'


function LoginScreen() {

  const history = useNavigate()
  const location = useLocation()

  var redirect = location.search ? location.search.split('=')[1] : '/'
  if (redirect === 'success' || redirect === 'fail') {
    redirect = '/'
  }
  const tokenResult = location.search ? location.search.split('=')[1] : ""

  const dispatch = useDispatch()
  const userLogin = useSelector(state => state.userLogin)
  const { error, userInfo, loading } = userLogin

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [activationMessage, setActivationMessage] = useState('')



  const sumbitHandler = (e) => {
    e.preventDefault()//صفحه ریلود نمیشود
    dispatch(userLoginAction(email, password))
  }

  useEffect(() => {
    if (userInfo) {
      history(redirect)
    } else if (!userInfo) {
      switch (tokenResult) {
        case 'success':
          setActivationMessage('your account successfully activated. you can login')
          break;
        case 'fail':
          setActivationMessage('your Activation link is not valid. please go to register and try again.')
          break;
        default:
          setActivationMessage('')

      }
    }
  }, [history, userInfo, redirect, tokenResult])


  return (

    <FormContainer>

      <h1>sign in</h1>
      {
        loading ? <Loader />
          : error ? <Message variant='danger' text={error} />
            : tokenResult === 'success' ? <Message variant='success' text={activationMessage} />
              : tokenResult === 'fail' ? <Message variant='danger' text={activationMessage} />
                : <></>
      }
      <Form
        onSubmit={sumbitHandler}
      >
        <Form.Group controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type='email'
            placeholder='Enter Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>

        </Form.Group>
        <Form.Group controlId='password' className='my-4'>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Enter Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>

        </Form.Group>
        <Button
          type='submit'
          variant='primary'
          className='col-4'
        >sign in</Button>

      </Form>
      {/* <Row className='my-4'>
        <Col>
          New Customer?
          <Link to={redirect ? `${FRONT_URL}/register?redirect=${redirect}` : `${FRONT_URL}/register`}>
            Register
          </Link>
        </Col>
      </Row> */}
    </FormContainer>
  )
}

export default LoginScreen
